"use client";

import { PageType, StrapiMedia } from "@/types";
import styles from "@/styles/BackToTop.module.scss";
import { useEffect, useState } from "react";
import StrapiImage from "./StrapiComponents/StrapiImage";

export const BackToTop = ({ page }: { page: PageType }) => {
	const [urlstring, setURL] = useState<string | null>(null);
	const handleScrollTop = () => {
		document.dispatchEvent(new Event("backToTop"));
	};

	const GetTeaserImageUrl = (image: StrapiMedia | null, alternativeImage: StrapiMedia | null): string | null => {
		const selectedImage = image ? image : alternativeImage;

		if (!selectedImage) {
			return null;
		}

		let url;
		if (selectedImage.formats && Object.prototype.hasOwnProperty.call(selectedImage.formats, "large")) {
			url = selectedImage.formats.large?.url;
		} else {
			url = selectedImage.url;
		}

		return (process.env.NEXT_PUBLIC_API_ORIGIN as string) + url;
	};
	const GetURL = () => {
		const currentURL = window.location.href;

		setURL(currentURL);
	};

	useEffect(() => {
		if (typeof window !== "undefined") {
			GetURL();
		}
	}, []);

	return (
		<section>
			<div className={styles.component}>
				<div
					className={styles.background}
					style={GetTeaserImageUrl(page.backToTopImage, page.teaser_image) ? { backgroundImage: `url(${GetTeaserImageUrl(page.backToTopImage, page.teaser_image)})` } : {}}
				></div>
				<button className="button-with-icon translate" onClick={handleScrollTop}>
					{/* <ThreeDIcon /> */}
					IN 3D ENTDECKEN
				</button>
				<div className="desktop-only">
					{urlstring && (
						<>
							<div className={`${styles.scanNote} translate`}>
								ODER SCANNE DIESEN CODE
								<br /> MIT DEINEM SMARTPHONE <br />
								{page.qrImage && (
									<div className={styles.qrcode}>
										<StrapiImage media={page.qrImage} loadingType={"eager"} />
									</div>
								)}
							</div>
							{/* <QRCodeComponent url={urlstring} /> */}
						</>
					)}
				</div>
			</div>
		</section>
	);
};
